// One place decides where the marketing site's public API calls go, so the sign-up form and the
// onboarding wizard can never disagree. In development Vite proxies /s1 to the local gateway;
// in a build, VITE_IDENTITY_API_URL wins and the production API is the fallback.
export const IDENTITY_API_BASE =
  import.meta.env.VITE_IDENTITY_API_URL
  || (import.meta.env.DEV ? '/s1' : 'https://api.communitynord.com/s1')

// The Communication service, for the contact form: through the gateway's /s4 prefix.
export const COMMUNICATION_API_BASE =
  import.meta.env.VITE_COMMUNICATION_API_URL
  || (import.meta.env.DEV ? '/s4' : 'https://api.communitynord.com/s4')

// The address custom domains point their A record at. Set VITE_PUBLIC_INGRESS_IP when it changes,
// instead of editing the success page.
export const PUBLIC_INGRESS_IP = import.meta.env.VITE_PUBLIC_INGRESS_IP || '92.220.141.98'
